// @actions
const errorActions = require('actions/brokerError');

// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const {
    BROKER_PENSION_PLAN_BENEFICIARIES_FETCHING,
    BROKER_PENSION_PLAN_BENEFICIARIES_FETCHING_SUCCESS,
    BROKER_PENSION_PLAN_BENEFICIARIES_FETCHING_ERROR
} = require('constants/actionTypes');

const loadBeneficiariesSuccess = (response) => (dispatch) => dispatch({
    type: BROKER_PENSION_PLAN_BENEFICIARIES_FETCHING_SUCCESS,
    payload: { response }
});

const loadBeneficiariesError = (error) => (dispatch) => dispatch({
    type: BROKER_PENSION_PLAN_BENEFICIARIES_FETCHING_ERROR,
    payload: { error }
});

const loadBeneficiaries = (product, contractNumber, history) => (dispatch) => {
    const request = {
        producto: product,
        numeroContrato: contractNumber
    };

    dispatch({
        type: BROKER_PENSION_PLAN_BENEFICIARIES_FETCHING
    });

    APIGet(dispatch, apiURLBuilder.getURL('planesBeneficiarios'), { query: request }).then(
        (response) => dispatch(loadBeneficiariesSuccess(response)),
        (error) => {
            dispatch(loadBeneficiariesError(error))
            dispatch(errorActions.show('', true, history));
        }
    );
};

module.exports = {
    loadBeneficiaries
};
